import { render } from "./WStatusAlertMute.vue?vue&type=template&id=2557a247&ts=true"
import script from "./WStatusAlertMute.vue?vue&type=script&lang=ts"
export * from "./WStatusAlertMute.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__